<template>
  <div
    class="select-input input"
    :class="{
      disabled,
      borderless,
      borderbottom,
      'padding-less': paddingLess,
      'dynamic-label': dynamicLabel
    }"
  >
    <label v-if="!!label" :class="{ mini: (dynamicLabel && !!((wrappedValue || placeholder) + '').length) }" >{{ label }} <span v-if="required && !!label">*</span></label>
    <div class="display" @click="toggle">
      <div class="value">{{ getDisplayText(wrappedValue) || placeholder }}</div>
      <font-awesome-icon class="drop" :icon="faCaretDown" />
    </div>
    <small class="red" v-if="!!validateMessage">{{ validateMessage }}</small>
    <transition name="fade">
      <div v-show="active" class="select-box-wrapper" ref="wrapper">
        <ul>
          <li
            v-for="item in items.filter((item) => !item.unenabled)"
            :key="item.value"
            @click="() => select(item.value)"
          >
            {{ item.text }}
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import { ref, watch, onUnmounted, computed } from '@vue/composition-api';
import $ from 'jquery';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';

export default {
  name: 'SelectInput',
  components: {
    FontAwesomeIcon
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    value: {
      type: [Number, String],
      default: null
    },
    placeholder: {
      type: String
    },
    label: {
      type: String
    },
    dynamicLabel: {
      type: Boolean
    },
    borderless: {
      type: Boolean,
      default: false
    },
    paddingLess: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    borderbottom: {
      type: Boolean,
      default: false
    },
    validate: {
      type: Function,
      default: () => ''
    }
  },
  setup(props, { refs, emit, root }) {
    const active = ref(false);
    const validateMessage = ref('');
    const isValid = ref(false);

    const wrappedValue = computed({
      get() { return props.value; },
      set(val) {
        emit('input', val);
      }
    });

    const toggle = (val) => {
      if ((val === false) || (val === true)) {
        active.value = val;
      } else {
        active.value = !active.value;
      }
    };

    const watchWrapper = (e) => {
      const elem = refs.wrapper;
      if (!elem) return;

      let { pageX, pageY } = e;
      let { top, left } = $(elem).offset();
      let width = $(elem).width();
      let height = $(elem).height();

      if ((pageX < left) || (pageX > left + width) || (pageY < top) || (pageY > top + height)) {
        ({ pageX, pageY } = e);
        ({ top, left } = $(elem).offset());
        width = $(elem).outerWidth();
        height = $(elem).outerHeight();

        if ((pageX < left) || (pageX > left + width) || (pageY < top) || (pageY > top + height)) {
          toggle(false);
        }
      }
    };

    const select = (val) => {
      emit('input', val);
      toggle(false);
    };

    const alert = (msg) => {
      validateMessage.value = msg;
    };

    const clearValidateMessage = () => {
      validateMessage.value = '';
    };

    const validateInputFunc = () => {
      const val = wrappedValue.value;

      if ((props.required) && !val) {
        alert(root.$t('REQUIRED_FIELD'));
        return false;
      }

      const msg = props.validate(val);

      if (msg) {
        alert(root.$t(msg));
        return false;
      }

      alert('');
      return true;
    };

    const validateInput = () => {
      const v = validateInputFunc();
      isValid.value = v;
      return v;
    };

    const getDisplayText = (val) => {
      const item = props.items.find((i) => (i.value === val));
      return item?.text || val;
    };

    watch(active, (next) => {
      if (next) {
        setTimeout(() => {
          $(document.body).on('click', watchWrapper);
        }, 0);
      } else {
        $(document.body).off('click', watchWrapper);
      }
    });

    watch(wrappedValue, (val) => {
      isValid.value = validateInput();
      if (val === '' && !props.required) {
        alert('');
      }
    });

    onUnmounted(() => {
      $(document.body).off('click', watchWrapper);
    });

    return {
      active,
      toggle,
      faCaretDown,
      wrappedValue,
      select,
      isValid,
      validateMessage,
      validateInput,
      getDisplayText,
      clearValidateMessage
    };
  }
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/colors';

.select-input {
  position: relative;
  display: inline-block;

  label {
    font-weight: bold;
    padding-left: 2px;
    color: $geranium;
    font-size: 14px;
    margin-bottom: 3px;
    pointer-events:none;

    span {
      color: $geranium;
    }
  }

  .display {
    height: 40px;
    border: 1px solid $independence;
    cursor: pointer;
    padding: 4px 15px;
    position: relative;
    text-align: left;

    .value {
      display: inline-block;
      padding-top: 3px;
    }

    svg {
      position: absolute;
      top: 50%;
      right: 15px;
      transform: translateY(-50%);
    }
  }

  small {
    &.red {
      color: $geranium;
    }
  }

  &.borderbottom {
    label {
      color: $blueNcs;
      margin-bottom: 0;
    }

    .display {
      border: 0;
      border-bottom: 1px solid $alto;
      padding-left: 2px;
      padding-top: 2px;
      height: 30px;
      font-size: 14px;
      margin-top: -5px;
    }
  }

  &.borderless {
    .display {
      border: 0;
    }
  }

  &.padding-less {
    .display {
      padding: 0;
    }
  }

  .select-box-wrapper {
    position: absolute;
    top: 100%;
    right: 0;
    box-shadow: 0px 3px 6px #00000029;
    background-color: $white;
    z-index: 999;
    box-sizing: border-box;
    max-height: 300px;
    overflow-y: scroll;
    width: 100%;
    min-width: 80px;

    &.fade-enter-active, &.fade-leave-active {
      transition: opacity .2s ease-in-out;
    }

    &.fade-enter, &.fade-leave-to {
      opacity: 0;
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      text-align: left;

      li {
        padding: 5px 15px;
        transition: all .2s ease-in-out;
        cursor: pointer;

        &:hover {
          background-color: $blueNcs;
          color: $white;
        }
      }
    }
  }

  &.dynamic-label {
    label {
      position: absolute;
      top: 0px;
      left: 0px;
      height: 40px;
      padding: 9px 11px;
      font-size: 15px;
      font-weight: normal;
      transition: all .2s ease-in-out;
      color: $lavenderGrey;

      &.mini {
        font-size: 12px;
        font-weight: bold;
        height: auto;
        padding: 3px 7px;
        background-color: $babyPowder;
        left: 15px;
        transform: translateY(-50%);
        z-index: 9;
        color: $independence;
      }
    }
  }

  &.disabled {
    label {
      color: $grey;
    }
  }
}
</style>
